import PropTypes from 'prop-types'
import React from 'react'
import { Route } from 'react-router-dom'

import withAuth from 'components/withAuth'

export function RouteWithAuth({
  component: Component, loading, user, ...others
}) {
  if (loading) return null

  return (
    <Route
      {...others}
      render={
        (props) => {
          if (loading) return null

          if (user) {
            return (
              <Component {...props} userEmail={user.email} />
            )
          }

          return (
            <Component {...props} />
          )
        }
      }
    />
  )
}

RouteWithAuth.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
  ]),
  loading: PropTypes.bool,
  user: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.object,
  ]),
}

export default withAuth(RouteWithAuth)


// WEBPACK FOOTER //
// ./src/components/RouteWithAuth/RouteWithAuth.js